import React from 'react';

const InquirySection = ({ service, message, onMessageChange, onSendMessage }) => {
  return (
    <div className="card">
      <div className="header">
        <h2><strong>Request</strong> Inquiry</h2>
      </div>
      <div className="body">
        <div>
          {service.claimed ? (
            <div>
              <textarea
                rows={4}
                className="form-control no-resize"
                placeholder="Please type your inquiry or request here…."
                value={message}
                onChange={e => onMessageChange(e.target.value)}
              />
              <button className="btn btn-primary" onClick={onSendMessage}>Send Message</button>
            </div>
          ) : (
            <p>
              This service is unclaimed. Please contact through their email or phone number below. 
              Remember to mention enableSEND so they can be part of our community!
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default InquirySection; 